import React from 'react';
import PlanOverview from './PlanOverview';
import Upgrade from './Upgrade';
import { Route, Switch } from 'react-router';
import CancelSubscription from './CancelSubscription';

const Plan = () => {
  return (
    <Switch>
      <Route path="/billing/plan" exact>
        <PlanOverview />
      </Route>

      <Route path="/billing/plan/upgrade">
        <Upgrade />
      </Route>

      <Route path="/billing/plan/cancel">
        <CancelSubscription />
      </Route>
    </Switch>
  );
};

export default Plan;
